//import * as React from "react"
import React,{useState} from "react"
import {bgStyleBlue,whiteLink} from './shared.module.scss'
import {boxShadow} from './communityHeader.module.scss'
import DropdownSearchNav from './tiny_components/dropdownSearchNav'
import { Link } from "gatsby"

const CorporateHeader = ()=>{

    const [menuClicked, setMenuClicked] = useState(false)

    return(
        <section className={bgStyleBlue+' '+boxShadow}>
            <div className=" container">

                <div className="columns">
                    <div className="column">
            <nav className={bgStyleBlue+" navbar is-fixed-top"} role="navigation" aria-label="main navigation" >
              <div className={bgStyleBlue+" navbar-brand"} style={{padding:'1rem'}}>
                  <h1 className="subtitle is-size-3" style={{marginBottom:'0'}} id="corporate_header_logo">&nbsp;&nbsp;<Link to="/" className={whiteLink}>
                    <img src="/imgs/mcklogo.png" alt="A McKinley Property" style={{maxWidth:'115px'}}/></Link></h1>
                              <a role="button" className="navbar-burger" 
                                  aria-label="menu" 
                                  aria-expanded="false" 
                                  onClick={()=>{setMenuClicked(!menuClicked)}}
                                  data-target="navbarMenu">
                                  <span aria-hidden="true"></span>
                                  <span aria-hidden="true"></span>
                                  <span aria-hidden="true"></span>
                              </a>
              </div>
                <div className={menuClicked ? "is-active "+bgStyleBlue+" navbar-menu" : bgStyleBlue+" navbar-menu"}>
                  <div className=" navbar-end" style={{marginRight:'2rem'}}>
                        <DropdownSearchNav menuClicked={menuClicked} />
                        <Link to="/residentportals/" className={menuClicked ? " navbar-item":whiteLink+" navbar-item "} >
                            Residents
                        </Link>
                        <Link to="/vendors/" className={menuClicked ? " navbar-item":whiteLink+" navbar-item "} >
                            Vendors
                        </Link>
                        <Link to="/career/" className={menuClicked ? " navbar-item":whiteLink+" navbar-item "} >
                            Careers
                        </Link>
                        <Link to="/about/" className={menuClicked ? " navbar-item":whiteLink+" navbar-item "}>
                            About
                        </Link>
                  </div>
              </div>

            </nav>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default CorporateHeader
